import React from 'react'
import { Grid } from '@fs/zion-ui'
import { css } from '@linaria/core'

const noParagraphPaddingCss = css`
  & p {
    padding: 0;
  }
`
type Props = {
  children: React.ReactNode
  inline?: boolean
}
export default function ConclusionBodyWrapper({ children, inline }: Props): JSX.Element {
  const Comp = inline ? 'span' : 'div'
  return (
    <Comp className={noParagraphPaddingCss} data-testid="conclusion-body">
      {!inline && <Grid guttersY="nano">{children}</Grid>}
      {inline && children}
    </Comp>
  )
}
